import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import tabReducer from './tabSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    tab: tabReducer,
  },
});

export default store;